/**
 * Number / percent formatters for tooltips and legend. Spanish locale:
 * dot for thousands, comma for decimals. The map's tooltip uses 'pt'
 * (Portuguese) which produces the same separators; we use 'de-DE' for
 * the same effect and explicit `minimumFractionDigits` for percentages.
 */

export function fmtNum(n) {
  if (n == null || isNaN(n)) return '—';
  return n.toLocaleString('de-DE');
}

/**
 * @param {number} n
 * @param {number} [digits=1]
 * @param {boolean} [withSign=true] include the % sign
 */
export function fmtPct(n, digits = 1, withSign = true) {
  if (n == null || isNaN(n)) return '—';
  const str = n.toLocaleString('de-DE', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  });
  return withSign ? str + '%' : str;
}
